export const KEYS = {
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  ENTER: 13,
  ESC: 27,
  TAB: 9,
  SPACE: 32
};

export const KEYS_DIRECTION = {
  37: -1,
  38: -1,
  39: 1,
  40: 1
};
